/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Component_SelfInputs */

const vi_error_combo_component_self = /** @type {(inputs: Error_Combo_Component_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combo không thể có thành phần là chính nó. Bỏ dòng đó rồi lưu lại.`)
};

/**

* @param {Error_Combo_Component_SelfInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_component_self = /** @type {((inputs?: Error_Combo_Component_SelfInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Component_SelfInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_component_self(inputs)
});